export const PREMIUM_START_PARAM = 'premium';

export const isPremiumStartParam = (startParam?: string | null): boolean => startParam === PREMIUM_START_PARAM;
